import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import logo from "../../images/wpp/logo_B.png";
import logout from "../../images/log-out.svg";
import { ReactComponent as MenuBars } from "../../images/menu-bars.svg";
import { ReactComponent as XBar } from "../../images/x-icon.svg";
import { useStyles } from './Header.styles';
import { useOktaAuth } from '@okta/okta-react';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { useT } from '../../../i18n';


interface IProps {
  handleClick: () => void;
  isActive: boolean;
}

const HeaderComponent = (props: IProps) => {
  const { handleClick, isActive } = props;
  const Bars = isActive ? XBar : MenuBars;
  const classes = useStyles();
  const t = useT();
  const { authState, oktaAuth } = useOktaAuth();
  const [userName, setUsername] = useState("");
  const location = useLocation();
  const history = useHistory();
  const isAssetControl = location.pathname.startsWith('/control-activos');
  const isAdmin = location.pathname.startsWith('/admin');
  const isReports = location.pathname.startsWith('/reportes');
  const isProfile = location.pathname.startsWith('/perfil');
  const isSkills = location.pathname.startsWith('/skills');
  const appName = isAssetControl
    ? t('header.app.assets') : isReports
    ? t('header.app.reports')
    : isAdmin
    ? t('header.app.admin')
    : isProfile
    ? t('header.app.profile')
    : isSkills
    ? t('header.app.skills')
    : t('header.app.deskbooking');


  useEffect(() => {
    if (authState?.isAuthenticated) {
      oktaAuth.getUser().then(
        (result) => {
          if (result.given_name && result.family_name) {
            setUsername(result.given_name + " " + result.family_name);
          }
        },
        () => undefined
      )
    }
  }, [authState, oktaAuth])

  const logOutRedirect = async () => {
    await oktaAuth.signOut();
  };

  const initials = userName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  return (
    <header className={classes.header}>
        <button
          type="button"
          className={classes.expand_collapse_button}
          onClick={handleClick}
          aria-expanded={isActive}
          aria-controls="nav-items"
          aria-label={isActive ? t('header.closeMenu') : t('header.openMenu')}
        >
          <Bars className={classes.expand_collapse_icon} />
        </button>
        <div className={classes.branding}>
          <img src={logo} className={classes.logo} alt={"WPP Enterprise Solutions"} />
          <span className={classes.appName}>{appName}</span>
        </div>
      <div className={classes.header_right}>
        <LanguageSelector />
        {userName && (
          <button
            type="button"
            className={`${classes.profile_button} ${isProfile ? classes.profile_button_active : ''}`}
            onClick={() => history.push('/perfil')}
            aria-label={t('header.viewProfileOf', { name: userName })}
            aria-current={isProfile ? 'page' : undefined}
            title={t('header.myProfileTitle')}
          >
            <span className={classes.profile_avatar} aria-hidden="true">{initials}</span>
            <span className={classes.user_label}>{userName}</span>
          </button>
        )}
        <button className={classes.logout_button} onClick={logOutRedirect}>
          <span className={classes.logout_label}>{t('header.logout')}</span>
          <img src={logout} className={`${classes.log_out_icon}`} alt="logout icon" />
        </button>
      </div>
    </header>
  );
};

export default HeaderComponent;

